import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../../components/forms/input'
import MyRichText from '../../../components/forms/richText'
import MyCollegeSelect from '../../../components/select/collegeSelect'
import MyImageUpload from '../../../components/forms/imageUpload'

const AddMajor = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '专业名称不能为空'})
      return false
    }
    if (!formValue.college_oid) {
      setErrorMsg({collegeEmpty: '所属院系不能为空'})
      return false
    }

    axios.post('/p/info/major/add', {
      merchant_oid: merchantOid,
      college_oid: formValue.college_oid,
      name: formValue.name,
      sort: Number(formValue.sort),
      icon: formValue.icon,
      introduction: formValue.introduction
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('新专业创建成功！')
          props.getMajorList()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({college_oid: formValue.college_oid})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <>
      <Modal
        destroyOnClose={true}
        title="创建专业"
        width='760px'
        open={props.isOpen}
        onCancel={handleCancel}
        maskClosable={false}
        footer={[
          <Button key='cancel' onClick={handleCancel}>取消</Button>,
          <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
          <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
        ]}>

        <MyImageUpload 
          id="icon"
          label='图标'
          value={formValue.icon}
          setValue={setFormValue}
        />

        <MyInput
          id="name"
          required
          autoFocus
          maxLength={64}
          label='名称'
          placeholder='请输入专业的名称'
          value={formValue.name}
          onChange={setFormValue}
          errorMsg={errorMsg.nameEmpty}
        />

        <MyRichText
          id='introduction'
          label='专业介绍'
          value={formValue.introduction}
          setValue={setFormValue}
        />

        <MyCollegeSelect
          id='college_oid'
          required
          label='选择院系'
          value={formValue.college_oid}
          onChange={setFormValue}
          errorMsg={errorMsg.collegeEmpty}
        />

        <MyInput
          type='number'
          id="sort"
          label='排序'
          value={formValue.sort}
          onChange={setFormValue}
          styles={{ width: '60px' }}
          min={0}
          max={1000}
        />
      </Modal>
    </>
  )
}

export default AddMajor
